import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AreaLayer from "../components/AreaLayer";

const AreaPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Area">
        <AreaLayer />
      </MasterLayout>
    </>
  );
};

export default AreaPage;
